module.exports = angular.module('msi.payments.select', [
  'ui.router',
  require('../dropdown'),
  require('@ordergroove/brandy/src/app/toasts')
]).name;

angular.module(module.exports)
  .config(require('./state'));
